// @ts-nocheck
import React, { useState, useEffect } from 'react';
import SettingsMenu from '@/components/settings/menu';
import Router from 'next/router';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import ImportsTable from "@/PageComponents/Table/Component Tables/ImportsTable";
import {Box, Card, Flex, Stack} from "@mantine/core";
import ImportRunsDashboard from "@/components/import-wizard/ImportRunsDashboard";
import { createFileRoute } from '@tanstack/react-router'



function ImportList(props: any) {


  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const [accessStatus, setAccessStatus] = useState<any>(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };


  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  return (
    <div className="settings-container">
      <Flex justify={'space-between'}>
        <SettingsMenu urlPath={currPath} />
        <Box
            w={'100%'}
            miw={0}
        >
          <Stack gap={'md'}>
            <Card
                shadow={'md'}
                withBorder
                style={{
                  backgroundColor: 'white'
                }}
                p={'var(--mantine-spacing-md)'}
                radius={'md'}
            >
              <ImportRunsDashboard />
            </Card>
            <Card
                shadow={'md'}
                withBorder
                style={{
                  backgroundColor: 'white'
                }}
                p={'var(--mantine-spacing-md)'}
                radius={'md'}
            >
              <ImportsTable />
            </Card>
          </Stack>
        </Box>
      </Flex>
    </div>
  );
}

export default ImportList;

export const Route = createFileRoute('/_authenticated/settings/import/list')({ component: ImportList })
